import React, {useCallback, useEffect, useState} from "react";
import {
	View,
	Panel,
	PanelHeader,
	Group,
	FormItem,
	Input,
	Button,
	Spinner,
	Separator,
	Link
} from "@vkontakte/vkui";
import Stat from "../rest/Stat";
import StatBadge from "../components/StatBadge";

const formatBytes = (bytes) => {
	const n = Number(bytes) || 0;
	if (n < 1024) {
		return `${n} B`;
	}
	if (n < 1024 * 1024) {
		return `${(n / 1024).toFixed(1)} KB`;
	}
	return `${(n / (1024 * 1024)).toFixed(2)} MB`;
};

const formatDate = (mtimeMs) => {
	try {
		return new Date(mtimeMs).toLocaleString("ru-RU");
	} catch (e) {
		return "";
	}
};

export const StatGatePanel = ({id, onAuthenticated}) => {
	const [login, setLogin] = useState("");
	const [password, setPassword] = useState("");
	const [error, setError] = useState("");
	const [busy, setBusy] = useState(false);

	const submit = () => {
		setError("");
		const u = login.trim();
		const p = password;
		if (!u || !p) {
			setError("Введите логин и пароль");
			return;
		}
		setBusy(true);
		Stat.auth(u, p).then((r) => {
			setBusy(false);
			if (r.data.auth && r.data.token) {
				Stat.setToken(r.data.token);
				onAuthenticated();
			} else {
				setError("Неверный логин или пароль");
			}
		}).catch(() => {
			setBusy(false);
			setError("Ошибка сети или сервера");
		});
	};

	return (
		<View activePanel={id}>
			<Panel id={id}>
				<PanelHeader transparent />
				<Group>
					<StatBadge />
					<form
						onSubmit={(e) => {
							e.preventDefault();
							submit();
						}}
					>
						<FormItem top="Логин">
							<Input
								type="text"
								value={login}
								onChange={(e) => setLogin(e.currentTarget.value)}
								autoComplete="username"
								disabled={busy}
							/>
						</FormItem>
						<FormItem top="Пароль">
							<Input
								type="password"
								value={password}
								onChange={(e) => setPassword(e.currentTarget.value)}
								autoComplete="current-password"
								disabled={busy}
							/>
						</FormItem>
						{error ? (
							<FormItem>
								<div style={{color: "var(--vkui--color_text_negative)", fontSize: 14}}>{error}</div>
							</FormItem>
						) : null}
						<FormItem>
							<Button type="submit" size="l" stretched loading={busy} disabled={busy}>
								Войти
							</Button>
						</FormItem>
					</form>
				</Group>
			</Panel>
		</View>
	);
};

const StatPanel = ({id, onLogout}) => {
	const [files, setFiles] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState("");

	const refresh = useCallback(() => {
		setLoading(true);
		setError("");
		return Stat.getFilesInfo().then((r) => {
			setFiles(Array.isArray(r.data.files) ? r.data.files : []);
			setLoading(false);
		}).catch((err) => {
			setLoading(false);
			if (err.response && err.response.status === 401) {
				Stat.setToken(null);
				onLogout();
				return;
			}
			setError("Не удалось получить список файлов");
		});
	}, [onLogout]);

	useEffect(() => {
		refresh();
	}, [refresh]);

	const handleLogout = () => {
		Stat.logout().finally(() => {
			Stat.setToken(null);
			onLogout();
		});
	};

	return (
		<View activePanel={id}>
			<Panel id={id}>
				<PanelHeader transparent />
				<Group>
					<StatBadge />
					<FormItem>
						<div style={{fontSize: 14, lineHeight: 1.45, opacity: 0.85}}>
							По FTP в <b>stat_private</b> загружайте <b>stat_wet.html</b> и <b>json-stat.json</b>.
							Ссылка <b>stat.html</b> — обёртка с кнопкой «Обновить», подгружает <b>stat_wet.html</b>.
						</div>
					</FormItem>
					{loading ? (
						<FormItem>
							<Spinner size="medium" />
						</FormItem>
					) : null}
					{error ? (
						<FormItem>
							<div style={{color: "var(--vkui--color_text_negative)", fontSize: 14}}>{error}</div>
						</FormItem>
					) : null}
					{!loading && files.map((file) => (
						<FormItem key={file.fileName} top={file.fileName}>
							{file.wrapper || file.exists ? (
								<>
									{file.wrapper ? (
										<div style={{fontSize: 14, marginBottom: 8, opacity: 0.85}}>
											Обёртка на сервере. Контент — из stat_wet.html по FTP.
										</div>
									) : (
										<div style={{fontSize: 14, marginBottom: 8}}>
											{formatBytes(file.size)} · обновлён {formatDate(file.mtimeMs)}
										</div>
									)}
									<Link href={Stat.fileUrl(file.fileName)} target="_blank">
										Открыть {file.fileName}
									</Link>
								</>
							) : (
								<div style={{fontSize: 14, opacity: 0.8}}>Файл ещё не загружен по FTP</div>
							)}
						</FormItem>
					))}
					<Separator />
					<FormItem>
						<Button size="l" mode="secondary" stretched onClick={refresh} disabled={loading}>
							Обновить
						</Button>
					</FormItem>
					<FormItem>
						<Button size="l" mode="tertiary" stretched onClick={handleLogout}>
							Выйти
						</Button>
					</FormItem>
				</Group>
			</Panel>
		</View>
	);
};

export default StatPanel;
